import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface IsOcrInvoiceNumberDuplicateRequest {
  companyId: string;
  invoiceNumber: string;
  supplierId: number;
}

const useIsExistingOcrDocumentApi = () => {
  const call = useCallback(async (body?: IsOcrInvoiceNumberDuplicateRequest) => {
    try {
      const res = await axiosInstance.post<boolean>(api.checkIsExistingOcrDocument(), body);
      return res.data as boolean;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false, undefined, false);

  return {
    checkIsExistingOcrDocument: execute,
    isExistingOcrCallLoading: isLoading,
  };
};

export default useIsExistingOcrDocumentApi;
